import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import extractText from 'flarum/common/utils/extractText';
import BirthdayList from './BirthdayList';
import BirthdayListState from '../states/BirthdayListState';
export default class BirthdaysPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.list = new BirthdayListState();
    this.list.refresh();
    app.history.push('birthdays', extractText(app.translator.trans('datlechin-birthdays.forum.page.title')));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle(extractText(app.translator.trans('datlechin-birthdays.forum.page.title')));
    app.setTitleCount(0);
  }
  view() {
    return m(PageStructure, {
      className: "BirthdaysPage",
      hero: () => m(WelcomeHero, null),
      sidebar: () => m(IndexSidebar, null)
    }, m(BirthdayList, {
      state: this.list
    }));
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/BirthdaysPage', BirthdaysPage);